export const Portfolio = {
    list: [
        {
            id: 2,
            name: 'StockRadars',
            img_dir_name: 'stockradars-trade',
            img_preview: 'preview',
            images: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]
        },

        {
            id: 4,
            name: 'Open Radars Management Console',
            img_dir_name: 'ormc',
            img_preview: 'preview',
            images: [1, 2, 3, 4, 5, 6]
        },

        {
            id: 8,
            name: 'Radars School',
            img_dir_name: 'radars-school',
            img_preview: 'preview',
            images: [1]
        },

        {
            id: 3,
            name: 'FundRadars',
            img_dir_name: 'fundradars',
            img_preview: 'preview',
            images: [1, 2, 3, 4, 5, 6, 7]
        },

        {
            id: 7,
            name: 'Globlex Admin',
            img_dir_name: 'globlex-admin',
            img_preview: 'preview',
            images: [1, 2, 3, 4]
        },

        {
            id: 9,
            name: 'StockRadars CI',
            img_dir_name: 'stockradars-ci',
            img_preview: 'preview',
            images: [1]
        },
        {
            id: 5,
            name: 'Bualuang CMS',
            img_dir_name: 'bl-cms',
            img_preview: 'preview',
            images: [1, 2, 3, 4, 5, 6, 7]
        }, {
            id: 6,
            name: 'Bualuang Fund',
            img_dir_name: 'bl-fund',
            img_preview: 'preview',
            images: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        },

        {
            id: 11,
            name: 'Carbonradars.io',
            img_dir_name: 'carbonradars',
            img_preview: 'preview',
            images: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        },

        {
            id: 10,
            name: 'Carboneum.io',
            img_dir_name: 'carboneum',
            img_preview: 1,
            images: [1, 2, 3, 4, 5, 6, 7]
        },

        {
            id: 11,
            name: 'Cosmetic ecommerce',
            img_dir_name: 'cosmetic_ecommerce',
            img_preview: 1,
            images: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        },
        {
            id: 12,
            name: 'Retirement Checkup',
            img_dir_name: 'retirement_checkup',
            img_preview: 1,
            images: [1, 2, 3, 4, 5, 6, 7]
        },
        {
            id: 14,
            name: 'Survey Police',
            img_dir_name: 'survey_police',
            img_preview: 1,
            images: [1, 2, 3, 4, 5, 6, 7, 8, 9]
        },
        {
            id: 13,
            name: 'Welt active one',
            img_dir_name: 'welt',
            img_preview: 'preview',
            images: [1]
        },
        {
            id: 17,
            name: 'Kong Service',
            img_dir_name: 'kong-service',
            img_preview: 'preview',
            images: [1]
        },
        {
            id: 16,
            name: 'Khaohinsorn',
            img_dir_name: 'khaohinsorn',
            img_preview: 1,
            images: [1]
        },
        {
            id: 15,
            name: 'Fitness',
            img_dir_name: 'fitness',
            img_preview: 1,
            images: [1]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/app/shared/profile/mock-portfolio.ts